import { io } from "socket.io-client";
import mitt from "mitt";

export default {
  install(app) {
    const emitter = mitt();
    var connection = null;
    const config = {
      host: "",
      port: "",
      timeout: "",
    };
    var status = false;

    const socket = {
      emitter,

      getStatus() {
        return status;
      },
      getConfig() {
        return config;
      },
      startConnection() {
        connection = io("https://pharmatech-mywarehouse.myweb.net.au", {
          reconnection: true,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          reconnectionAttempts: 5,
        });

        connection.on("connect", () => {
          status = true;
          emitter.emit("status", status);
        });

        connection.on("connect_error", () => {
          status = false;
          emitter.emit("status", status);
        });

        connection.on("init", ({ host, port, timeout }) => {
          config.host = host;
          config.port = port;
          config.timeout = timeout;
        });

        connection.on("connected", () => {
          console.log("connected: ");
        });

        connection.on("wrote", () => {
          console.log("wrote: ");
        });
      },

      connect({ host, port, timeout }) {
        console.log("connect: ", host, port, timeout);
        connection.emit("connect-device", { host, port, timeout });
      },

      write(data) {
        connection.emit("write", { data });
      },
    };

    socket.startConnection();
    app.config.globalProperties.$printerHub = socket;
  },
};
